(function(){
  var WISHLIST_KEY='chauxe_wishlist_v1';
  var RECENT_KEY='chauxe_recent_v1';
  function read(key){try{var value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value:[]}catch(e){return []}}
  function write(key,value){try{localStorage.setItem(key,JSON.stringify(value))}catch(e){}}
  function clean(value){return String(value==null?'':value)}
  function escapeHtml(value){return clean(value).replace(/[&<>"']/g,function(char){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]})}
  function itemFromButton(button){return{handle:clean(button.dataset.productHandle),title:clean(button.dataset.productTitle),url:clean(button.dataset.productUrl),image:clean(button.dataset.productImage),price:clean(button.dataset.productPrice)}}
  function valid(item){return item&&item.handle&&item.title&&item.url}
  function wishlist(){return read(WISHLIST_KEY).filter(valid)}
  function recent(){return read(RECENT_KEY).filter(valid)}
  function has(handle){return wishlist().some(function(item){return item.handle===handle})}
  function updateCounts(){
    var count=wishlist().length;
    document.querySelectorAll('[data-chauxe-wishlist-count]').forEach(function(el){el.textContent=count?String(count):''});
  }
  function updateButtons(){
    document.querySelectorAll('[data-chauxe-wishlist-toggle]').forEach(function(button){
      var active=has(button.dataset.productHandle);
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
      button.setAttribute('title',active?'Retirer des favoris':'Ajouter aux favoris');
      var label=button.querySelector('[data-chauxe-wishlist-label]');
      if(label) label.textContent=active?'Retirer des favoris':'Ajouter aux favoris';
    });
    updateCounts();
  }
  function card(item,removable){
    var image=item.image?'<img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.title)+'" loading="lazy" width="720" height="828">':'';
    var remove=removable?'<button type="button" class="chauxe-saved-card__remove" data-chauxe-wishlist-remove="'+escapeHtml(item.handle)+'" aria-label="Retirer '+escapeHtml(item.title)+' des favoris"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg></button>':'';
    return '<article class="chauxe-saved-card">'+remove+'<a class="chauxe-saved-card__image" href="'+escapeHtml(item.url)+'">'+image+'</a><div class="chauxe-saved-card__body"><h3 class="chauxe-saved-card__title"><a href="'+escapeHtml(item.url)+'">'+escapeHtml(item.title)+'</a></h3><p class="chauxe-saved-card__price">'+escapeHtml(item.price)+'</p></div></article>';
  }
  function renderWishlist(){
    document.querySelectorAll('[data-chauxe-wishlist-grid]').forEach(function(grid){
      var items=wishlist();
      grid.innerHTML=items.map(function(item){return card(item,true)}).join('');
      var empty=grid.parentElement.querySelector('[data-chauxe-wishlist-empty]');
      if(empty) empty.classList.toggle('is-visible',items.length===0);
    });
  }
  function renderRecent(currentHandle){
    document.querySelectorAll('[data-chauxe-recent-grid]').forEach(function(grid){
      var items=recent().filter(function(item){return item.handle!==currentHandle}).slice(0,4);
      grid.innerHTML=items.map(function(item){return card(item,false)}).join('');
      var section=grid.closest('[data-chauxe-recent-section]');
      if(section) section.hidden=items.length===0;
    });
  }
  function trackCurrent(){
    var element=document.getElementById('ChauxeCurrentProductData');
    if(!element)return '';
    try{
      var item=JSON.parse(element.textContent);
      if(!valid(item))return '';
      var items=recent().filter(function(existing){return existing.handle!==item.handle});
      items.unshift(item);write(RECENT_KEY,items.slice(0,8));return item.handle;
    }catch(e){return ''}
  }
  document.addEventListener('click',function(event){
    var toggle=event.target.closest('[data-chauxe-wishlist-toggle]');
    if(toggle){
      event.preventDefault();event.stopPropagation();
      var item=itemFromButton(toggle);if(!valid(item))return;
      var items=wishlist();var index=items.findIndex(function(existing){return existing.handle===item.handle});
      if(index>=0)items.splice(index,1);else items.unshift(item);
      write(WISHLIST_KEY,items);updateButtons();renderWishlist();return;
    }
    var remove=event.target.closest('[data-chauxe-wishlist-remove]');
    if(remove){
      var handle=remove.getAttribute('data-chauxe-wishlist-remove');
      write(WISHLIST_KEY,wishlist().filter(function(item){return item.handle!==handle}));
      updateButtons();renderWishlist();
    }
  });
  function init(){var currentHandle=trackCurrent();updateButtons();renderWishlist();renderRecent(currentHandle)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){updateButtons();renderWishlist();renderRecent('')});
})();